module.exports = __webpack_public_path__ + "img/3-Howdie-Home-Page-Banner-1.e4423984.png";